import type { ProjectStateLifecycle } from '@/Client/Layout/useProjectStateLifecycle';

/**
 * A designated Project Manager can approve individual, group, and scope tasks
 * without taking the work turn. Scope editing remains current-holder work.
 */
export const canApproveTurnBasedDraftTask = ({
  turnBasedHandoff,
  managerIds,
  userId,
}: {
  turnBasedHandoff: boolean;
  managerIds: readonly string[] | undefined;
  userId: string | undefined;
}): boolean =>
  turnBasedHandoff
  && !!userId
  && managerIds?.includes(userId) === true;

/**
 * A turn-based task or bulk approval control appears only for a draft. A
 * change-order draft has an approved project phase because its prior scope is
 * already approved, so it needs the same controls as an initial draft without
 * exposing them during ordinary approved work. The caller supplies the
 * appropriate task or bulk approval permission.
 */
export const turnBasedDraftOffersTaskApproval = ({
  projectStateLifecycle,
  scanIsChangeOrder,
  allowTurnBasedDraftApproval,
}: {
  projectStateLifecycle: ProjectStateLifecycle;
  scanIsChangeOrder: boolean;
  allowTurnBasedDraftApproval: boolean;
}): boolean =>
  allowTurnBasedDraftApproval
  && (projectStateLifecycle === 'edit' || (projectStateLifecycle === 'approved' && scanIsChangeOrder));
